/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  MedicationOcrRequestResponseDto,
  MedicationStatementResponseDto,
  MedicationStatementUpsertRequestDto,
  ProcessMedicationFileByPatientId201Response,
  ProcessMedicationFileDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    MedicationOcrRequestResponseDtoFromJSON,
    MedicationOcrRequestResponseDtoToJSON,
    MedicationStatementResponseDtoFromJSON,
    MedicationStatementResponseDtoToJSON,
    MedicationStatementUpsertRequestDtoFromJSON,
    MedicationStatementUpsertRequestDtoToJSON,
    ProcessMedicationFileByPatientId201ResponseFromJSON,
    ProcessMedicationFileByPatientId201ResponseToJSON,
    ProcessMedicationFileDtoFromJSON,
    ProcessMedicationFileDtoToJSON,
} from '../models/index';

export interface DeleteMedicationStatementRequest {
    medicationId: string;
}

export interface DeleteMedicationStatementByPatientIdRequest {
    patientId: string;
    medicationId: string;
}

export interface GetMedicationOcrRequestsRequest {
    page?: number;
    pageSize?: number;
}

export interface GetMedicationOcrStatusRequest {
    requestId: string;
}

export interface GetMedicationStatementsByPatientIdRequest {
    patientId: string;
}

export interface ProcessMedicationFileRequest {
    processMedicationFileDto: ProcessMedicationFileDto;
}

export interface ProcessMedicationFileByPatientIdRequest {
    patientId: string;
    processMedicationFileDto: ProcessMedicationFileDto;
}

export interface UpsertMedicationStatementRequest {
    medicationStatementUpsertRequestDto: MedicationStatementUpsertRequestDto;
}

export interface UpsertMedicationStatementByPatientIdRequest {
    patientId: string;
    medicationStatementUpsertRequestDto: MedicationStatementUpsertRequestDto;
}

/**
 * 
 */
export class PatientMedicationsApi extends runtime.BaseAPI {

    /**
     * Delete a medication statement
     */
    async deleteMedicationStatementRaw(requestParameters: DeleteMedicationStatementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['medicationId'] == null) {
            throw new runtime.RequiredError(
                'medicationId',
                'Required parameter "medicationId" was null or undefined when calling deleteMedicationStatement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/medication-statements/{medicationId}`.replace(`{${"medicationId"}}`, encodeURIComponent(String(requestParameters['medicationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a medication statement
     */
    async deleteMedicationStatement(requestParameters: DeleteMedicationStatementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMedicationStatementRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a medication statement by patient ID
     */
    async deleteMedicationStatementByPatientIdRaw(requestParameters: DeleteMedicationStatementByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling deleteMedicationStatementByPatientId().'
            );
        }

        if (requestParameters['medicationId'] == null) {
            throw new runtime.RequiredError(
                'medicationId',
                'Required parameter "medicationId" was null or undefined when calling deleteMedicationStatementByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/medication-statements/{patientId}/{medicationId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))).replace(`{${"medicationId"}}`, encodeURIComponent(String(requestParameters['medicationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a medication statement by patient ID
     */
    async deleteMedicationStatementByPatientId(requestParameters: DeleteMedicationStatementByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMedicationStatementByPatientIdRaw(requestParameters, initOverrides);
    }

    /**
     * Get list of medication OCR requests for the patient
     */
    async getMedicationOcrRequestsRaw(requestParameters: GetMedicationOcrRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/medication-statements/ocr-requests/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get list of medication OCR requests for the patient
     */
    async getMedicationOcrRequests(requestParameters: GetMedicationOcrRequestsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getMedicationOcrRequestsRaw(requestParameters, initOverrides);
    }

    /**
     * Get medication OCR processing status
     */
    async getMedicationOcrStatusRaw(requestParameters: GetMedicationOcrStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicationOcrRequestResponseDto>> {
        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling getMedicationOcrStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/medication-statements/ocr-status/{requestId}`.replace(`{${"requestId"}}`, encodeURIComponent(String(requestParameters['requestId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicationOcrRequestResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get medication OCR processing status
     */
    async getMedicationOcrStatus(requestParameters: GetMedicationOcrStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicationOcrRequestResponseDto> {
        const response = await this.getMedicationOcrStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get current medication statements for a patient
     */
    async getMedicationStatementsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicationStatementResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/medication-statements`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicationStatementResponseDtoFromJSON));
    }

    /**
     * Get current medication statements for a patient
     */
    async getMedicationStatements(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MedicationStatementResponseDto>> {
        const response = await this.getMedicationStatementsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get patient\'s medication statements by patient ID
     */
    async getMedicationStatementsByPatientIdRaw(requestParameters: GetMedicationStatementsByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicationStatementResponseDto>>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getMedicationStatementsByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/medication-statements/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicationStatementResponseDtoFromJSON));
    }

    /**
     * Get patient\'s medication statements by patient ID
     */
    async getMedicationStatementsByPatientId(requestParameters: GetMedicationStatementsByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MedicationStatementResponseDto>> {
        const response = await this.getMedicationStatementsByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Process a file to extract medication/supplement data via OCR
     */
    async processMedicationFileRaw(requestParameters: ProcessMedicationFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['processMedicationFileDto'] == null) {
            throw new runtime.RequiredError(
                'processMedicationFileDto',
                'Required parameter "processMedicationFileDto" was null or undefined when calling processMedicationFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/medication-statements/process-file`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProcessMedicationFileDtoToJSON(requestParameters['processMedicationFileDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Process a file to extract medication/supplement data via OCR
     */
    async processMedicationFile(requestParameters: ProcessMedicationFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.processMedicationFileRaw(requestParameters, initOverrides);
    }

    /**
     * Process a file to extract medication/supplement data via OCR for a patient
     */
    async processMedicationFileByPatientIdRaw(requestParameters: ProcessMedicationFileByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProcessMedicationFileByPatientId201Response>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling processMedicationFileByPatientId().'
            );
        }

        if (requestParameters['processMedicationFileDto'] == null) {
            throw new runtime.RequiredError(
                'processMedicationFileDto',
                'Required parameter "processMedicationFileDto" was null or undefined when calling processMedicationFileByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/medication-statements/process-file/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProcessMedicationFileDtoToJSON(requestParameters['processMedicationFileDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProcessMedicationFileByPatientId201ResponseFromJSON(jsonValue));
    }

    /**
     * Process a file to extract medication/supplement data via OCR for a patient
     */
    async processMedicationFileByPatientId(requestParameters: ProcessMedicationFileByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProcessMedicationFileByPatientId201Response> {
        const response = await this.processMedicationFileByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create or update a medication statement
     */
    async upsertMedicationStatementRaw(requestParameters: UpsertMedicationStatementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicationStatementResponseDto>> {
        if (requestParameters['medicationStatementUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'medicationStatementUpsertRequestDto',
                'Required parameter "medicationStatementUpsertRequestDto" was null or undefined when calling upsertMedicationStatement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/medication-statements`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MedicationStatementUpsertRequestDtoToJSON(requestParameters['medicationStatementUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicationStatementResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create or update a medication statement
     */
    async upsertMedicationStatement(requestParameters: UpsertMedicationStatementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicationStatementResponseDto> {
        const response = await this.upsertMedicationStatementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update patient\'s medication statements by patient ID
     */
    async upsertMedicationStatementByPatientIdRaw(requestParameters: UpsertMedicationStatementByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicationStatementResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling upsertMedicationStatementByPatientId().'
            );
        }

        if (requestParameters['medicationStatementUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'medicationStatementUpsertRequestDto',
                'Required parameter "medicationStatementUpsertRequestDto" was null or undefined when calling upsertMedicationStatementByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/medication-statements/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MedicationStatementUpsertRequestDtoToJSON(requestParameters['medicationStatementUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicationStatementResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update patient\'s medication statements by patient ID
     */
    async upsertMedicationStatementByPatientId(requestParameters: UpsertMedicationStatementByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicationStatementResponseDto> {
        const response = await this.upsertMedicationStatementByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
